import {
  COMPONENT_VALUE_TYPES as types,
} from 'shared/constants';

const propsSchema = [
  {
    key: 'header',
    label: 'Header',
    type: types.TEXT
  },
  {
    key: 'message',
    label: 'Message',
    type: types.TEXT
  },
  {
    key: 'eventUrl',
    label: 'Event URL',
    type: types.TEXT
  },
];

const defaultProps = {
  header: 'Header Text',
  message: 'Message Text',
  eventUrl: '/us/'
};

export default {
  title: 'CancelFreeRide',
  id: 'CancelFreeRide',
  propsSchema,
  defaultProps
};
